import React, { useEffect, useState } from 'react';
import { getPermission } from '../../Conexiones/Conexion';
import { FaUser,FaUserCheck} from "react-icons/fa";
import { GiScrew} from "react-icons/gi";
import {TbListCheck} from "react-icons/tb"
import { GoGraph } from "react-icons/go";
import { BiDollar } from "react-icons/bi";
import '../../CSS/Herramientas.css'
import { useNavigate } from 'react-router';
import ModalResumenObra from './ModalResumenObra';
import ResumenObraProyecto from './ResumenObraProyecto';
import { MdImageSearch } from "react-icons/md";
import { FaArrowLeftLong } from 'react-icons/fa6';
import { getApi } from '../../Conexiones/Models';
import { errorMessage } from '../../Utils/AlertMessage';
import Loading from '../../Utils/Loading';

function AdministracionObra() {
    /*const dataobras =[
        {id:1,nombre: "Mano de Obra",enlace: "Mano-Obra"},
        {id:2,nombre: "Asistencia Obra",enlace: "Asistencia-Obra"},
        {id:3,nombre: "Materiales",enlace: "Materiales"},
        {id:4,nombre: "Herramientas",enlace: "Herramientas"},
        {id:5,nombre: "Gastos Mano de Obra",enlace: "Gastos-Mano-Obra"},
        {id:6,nombre: "Gastos materiales",enlace: "Gastos-materiales"},
        {id:7,nombre: "Gastos Adicionales",enlace: "Gastos-Adicionales"},
        {id:8,nombre: "Gastos Maquinaria",enlace: "Gastos-Maquinaria"},
        {id:9,nombre: "Gastos Tramites",enlace: "Gastos-Tramites"},
        {id:10,nombre: "Actividades",enlace: "Actividad-Obra"},
        {id:11,nombre: "Bitácora",enlace: "Bitacora"}
    ]*/

    const icons =[<TbListCheck/>,<FaUserCheck/>,<MdImageSearch/>,<BiDollar/>,<BiDollar/>,<BiDollar/>,<BiDollar/>,<BiDollar/>,<FaUser/>,<GiScrew/>]
    const navigate = useNavigate();
    const [obra,setObra] = useState('');
    const nullProyecto=sessionStorage.getItem("proyectoNull");
    const [permisos,setPermisos]=useState([]);
    const [isLoading,setIsLoading]=useState(false);
    const uri = 'permAdmonObra/';

    useEffect (()=>{
        const getPermisosO = async () =>{
            setIsLoading(true);
            const usuario = JSON.parse(sessionStorage.getItem('user'));
            const idUsuario = usuario[0].idUsuario;
            const permiso = await getPermission(idUsuario,17);
            const obraId = parseInt(sessionStorage.getItem("obra"));
            if(permiso){
                const endpoint = uri + idUsuario + '/' + obraId;
                const res = await getApi(endpoint);
                if(res.status === 1){
                    if(res.data.length !== undefined){
                        setPermisos(res.data[0].permisos);
                        setObra(res.data[0].obra);
                    }else{
                        errorMessage(res.data.message);
                    }
                }else if(res.status === 210){
                    navigate('/');
                }else{
                    errorMessage(res.message);
                }
            }else{
                navigate('/inicio');
            }
            setIsLoading(false);
        }
        getPermisosO()
    },[navigate])

    const select = (direccion) => {
        navigate(direccion)
    }
    const regresar = () => {
        if (nullProyecto==="undefined"){
            navigate('/inicio/Proyectos/')
        }else{
            navigate('/inicio/Proyectos/Lista-Obras')
        }
    }

    //Resumen Proyecto
    const [showRP, setShowRP] = useState(false);
    const handleCloseRP = () => setShowRP(false);
    const handleShowRP = () => setShowRP(true);
    const [resumenP,setResumenP] = useState([]);
    const showResumenP = async () =>{
        const obraId = parseInt(sessionStorage.getItem("obra"));
        const endpoint = 'resumen-obrasProyectos/' + obraId;
        const res = await getApi(endpoint);
        if(res.status === 1){
            if(res.data.length !== undefined){
                setResumenP(res.data);
                handleShowRP();
            }else{
                errorMessage(res.data.message);
            }
        }else if(res.status === 210){
            navigate('/');
        }else{
            errorMessage(res.message);
        }
    }
    //Resumen 
    const [showRO, setShowRO] = useState(false);
    const handleCloseRO = () => setShowRO(false);
    const handleShowRO = () => setShowRO(true);
    const [resumenO,setResumenO] = useState([]);
    const showResumenO = async () =>{
        const obraId = parseInt(sessionStorage.getItem("obra"));
        const endpoint = 'resumen-obras/' + obraId;
        const res = await getApi(endpoint);
        if(res.status === 1){
            if(res.data.length !== undefined){
                setResumenO(res.data);
                handleShowRO();
            }else{
                errorMessage(res.data.message);
            }
        }else if(res.status === 210){
            navigate('/');
        }else{
            errorMessage(res.message);
        }
    }

    return (
        <div className='herramientas' >
            {
                isLoading === true ? 
                <Loading />:
                <div>
                    { nullProyecto==="undefined"?
                        (<ModalResumenObra show={showRO} handleClose={handleCloseRO} nombre={obra} total={resumenO} />):
                        (<ResumenObraProyecto show={showRP} handleClose={handleCloseRP} nombre={obra} total={resumenP} />)
                    }
                    <div className='contabilidades-header'>
                        <div className='fab'><FaArrowLeftLong className='arrow' onClick={regresar} title='REGRESAR'/></div>
                        <label className="text-uppercase">ADMINISTRACION DE OBRA</label>
                    </div>
                    <div>
                        <h4 className='text-uppercase'>{obra}</h4>
                    </div>
                    <div style={{padding:'20px'}}>
                        <div className="row row-cols-1 row-cols-md-4 g-4" >
                            <div className="col-sm-6 mb-3 mb-sm-0  " >
                                {
                                    nullProyecto==="undefined"?(
                                        <div className='card h-100 btncolor btn' style={{ marginTop: '20px', textAlign: "center", padding:'10px', fontSize:'20px'}} onClick={showResumenO} >
                                            <div style={{display:'flex', justifyContent:'space-between'}}>
                                                <div style={{justifyContent:'center'}}>Resumen</div>
                                                <div style={{fontSize:'20px',justifyContent:'center'}}><GoGraph /></div>
                                            </div>            
                                        </div>
                                    ):(
                                        <div className='card h-100 btncolor btn' style={{ marginTop: '20px', textAlign: "center", padding:'10px', fontSize:'20px'}} onClick={showResumenP} >
                                            <div style={{display:'flex', justifyContent:'space-between'}}>
                                                <div style={{justifyContent:'center'}}>Resumen</div>
                                                <div style={{fontSize:'20px',justifyContent:'center'}}><GoGraph /></div>
                                            </div>            
                                        </div>
                                    )
                                }
                            </div>
                            {
                                permisos.map((obras,idx) =>{
                                    //const Icon = icons[idx] 
                                    return(                            
                                        <div className="col-sm-6 mb-3 mb-sm-0 " key={obras.idModulo}>
                                        <div className='card h-100 btncolor btn' 
                                        style={{ marginTop: '20px', textAlign: "center", padding:'10px', fontSize:'20px'}} onClick={() => select(obras.enlace)}>
                                                <div style={{display:'flex', justifyContent:'space-between'}}>
                                                    <div style={{justifyContent:'center'}}>{obras.nomModulo}</div>
                                                    <div style={{fontSize:'20px',justifyContent:'center'}}>{icons[idx]}</div>
                                                </div>            
                                            </div>
                                        </div>
                                    )           
                                })
                            }
                        </div>
                    </div>
                </div>
            }
        </div>
    );
}

export default AdministracionObra;